module.exports = __webpack_public_path__ + "static/media/3.21a26def.jpg";